<template>
  <div class="bottom">
    
  </div>
</template>

<script>
  export default {
    data() {
      return{

      }
    },
    methods: {
    },
    created() {

    },
    mounted() {

    }
 }
</script>

<style  scoped>
.bottom {
  width: 100%;
  height: 150px;
  background-image: url('@/assets/image/index/index_back.png');
  display: flex;
  justify-content: space-between; /* 确保子元素之间的间距均匀分布 */
  align-items: center; /* 垂直居中 */
}

</style>
